import { FC } from 'react';

import { Link } from '@inertiajs/react';
import { CalendarDays } from 'lucide-react';

import { BlogPost } from '../../types';
import { formatDate } from '../../utils';

type PostsProps = {
    posts: BlogPost[];
};

export const Posts: FC<PostsProps> = ({ posts }) => (
    <div className="space-y-4">
        {posts.map((post) => (
            <article
                key={post.id}
                className="flex w-full gap-4 rounded-2xl border bg-card p-4 shadow-sm"
            >
                {post.cover_image_url ? (
                    <Link
                        href={post.url_path}
                        className="block w-24 flex-shrink-0 sm:w-32 md:w-40"
                    >
                        <img
                            src={post.cover_image_url}
                            alt={post.title}
                            className="block h-full w-full rounded-2xl object-cover"
                        />
                    </Link>
                ) : null}

                <div className="min-w-0 flex-1">
                    <div className="mb-3 flex items-center gap-3 text-xs text-muted-foreground">
                        <div className="flex items-center gap-2">
                            <CalendarDays className="h-4 w-4" />
                            <time dateTime={post.published_at}>
                                {formatDate(post.published_at)}
                            </time>
                        </div>

                        <div className="flex flex-wrap gap-1">
                            {(post.tags || []).map((tag) => (
                                <span
                                    key={tag}
                                    className="rounded-full bg-slate-200 px-2 py-0.5 text-xs font-medium text-slate-700"
                                >
                                    {tag}
                                </span>
                            ))}
                        </div>
                    </div>

                    <h2 className="mb-3 text-xl font-semibold">
                        <Link
                            href={post.url_path}
                            className="hover:text-primary"
                        >
                            {post.title}
                        </Link>
                    </h2>

                    <p className="mb-3 text-sm text-muted-foreground">
                        {post.excerpt}
                    </p>

                    <Link
                        href={post.url_path}
                        className="text-sm font-medium text-primary hover:underline"
                    >
                        Читати статтю
                    </Link>
                </div>
            </article>
        ))}
    </div>
);
